<template>
  <LazyUiDialog
    class="added-to-cart"
    name="add-to-cart"
    dialog-type="modal"
    @close="resetAddedToCart"
  >
    <template #dialogHeader>
      {{ $t('Added to cart') }}
    </template>

    <CartAddedItem
      v-if="addToCartContext"
      :item="addToCartContext.product"
      class="added-to-cart__product"
    >
      <div class="added-to-cart__product-buttons">
        <AppLink
          to="/cart"
          class="button button--cta"
          data-testid="add-to-cart-view-cart"
          @click="closeDialog()"
        >
          <span>{{ $t('View cart') }}</span>
        </AppLink>
        <button
          class="button button--link"
          :disabled="hasCartItemErrors"
          @click.prevent="checkout()"
        >
          <span>{{ $t('To checkout') }}</span>
        </button>
      </div>
    </CartAddedItem>

    <ProductSlider
      v-if="crossSellsAndRelatedProducts?.length"
      :products="crossSellsAndRelatedProducts"
      :show-cta="true"
      :custom-settings="{
        itemsToShow: 2,
        itemsToScroll: 1,
        snapAlign: 'start',
        breakpoints: {
          // 700px and up
          700: {
            itemsToShow: 2,
          },
          // 1024 and up
          1024: {
            itemsToShow: 3,
          },
        },
      }"
    >
      <span class="heading heading--6">{{ $t('Upsell products') }}</span>
    </ProductSlider>

    <div
      v-if="errors.length"
      class="error"
    >
      <ul>
        <li
          v-for="(error, index) in errors"
          :key="index"
        >
          <pre> {{ error }}</pre>
        </li>
      </ul>
    </div>
  </LazyUiDialog>
</template>

<script lang="ts" setup>
const { show: showErrorNotification } = useNotification()
const { hasCartItemErrors, errors } = useCart()
const { addToCartContext } = useAddToCart()
const addToCartDialog = useUiDialog('add-to-cart')
const router = useRouter()
const { storeConfig } = useStore()

const checkout = () => {
  router.push('/checkout/')
}
const closeDialog = () => {
  addToCartDialog.close()
}

const resetAddedToCart = () => {
  addToCartContext.value = undefined
}

const crossSellsAndRelatedProducts = computed(() => {
  return [
    ...(addToCartContext.value?.product.crossSellProducts || []),
    ...(addToCartContext.value?.product.relatedProducts || []),
  ]
})

watch(addToCartContext, async (newVal) => {
  if (!errors.value.length && newVal !== undefined && newVal.suppress !== true) {
    if (storeConfig.value?.code?.includes('bag_')) {
      router.push('/cart/')
      return
    }
    else {
      addToCartDialog.open()
    }
  }
})

watch(errors, (newVal) => {
  if (newVal.length) {
    showErrorNotification({ type: 'error', message: newVal.join(', ') })
  }
})
</script>

<style>
@import url("~layers/app/components/Cart/Added.css");
</style>
